import { useAtom } from "jotai";
import { Query } from "@repo/rq-api-public";
import Checkbox from "../ui/Checkbox";
import { cn } from "../../styles/utils";
import { textStyles } from "../../styles/typography";
import { cateringEmailOptInAtom, boatingClubEmailOptInAtom } from "./store";
import { useEffect } from "react";

export default function BoatingAndCateringOptIns() {
  const { data: platformAccountSettings } =
    Query.usePlatformAccountSettingsGETQuery();
  const showCatering =
    platformAccountSettings?.settings?.cateringEnabled ?? false;
  const showBoatClub =
    platformAccountSettings?.settings?.boatClubEnabled ?? false;

  const [cateringEmailOptIn, setCateringEmailOptIn] = useAtom(
    cateringEmailOptInAtom,
  );
  const [boatingClubEmailOptIn, setBoatingClubEmailOptIn] = useAtom(
    boatingClubEmailOptInAtom,
  );

  useEffect(() => {
    if (!showCatering) setCateringEmailOptIn(false);
    if (!showBoatClub) setBoatingClubEmailOptIn(false);
  }, [
    setBoatingClubEmailOptIn,
    setCateringEmailOptIn,
    showBoatClub,
    showCatering,
  ]);

  if (!showCatering && !showBoatClub) return null;

  return (
    <div
      className={cn(
        textStyles.body1,
        "widget-contact-form__opt-ins flex flex-col gap-3 text-blue-dark",
      )}
    >
      {showCatering && (
        <Checkbox
          id="cateringEmailOptIn"
          name="cateringEmailOptIn"
          label="Email me catering options"
          checked={cateringEmailOptIn}
          onChange={setCateringEmailOptIn}
        />
      )}
      {showBoatClub && (
        <Checkbox
          id="boatingClubEmailOptIn"
          name="boatingClubEmailOptIn"
          label="I'm interested in joining the seasonal Boat Club"
          checked={boatingClubEmailOptIn}
          onChange={setBoatingClubEmailOptIn}
        />
      )}
    </div>
  );
}
